import { render, staticRenderFns } from "./SocietyMatchesHandlePaymentView.vue?vue&type=template&id=08ba3038&scoped=true"
import script from "./SocietyMatchesHandlePaymentView.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesHandlePaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba3038",
  null
  
)

export default component.exports